import * as React from "react"
const WindowsSearch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M10.802 0a5.844 5.844 0 0 0-4.377 9.718L.708 16.207l.794.708 5.702-6.46A5.843 5.843 0 1 0 10.802.007V0Zm0 10.625a4.781 4.781 0 1 1 0-9.562 4.781 4.781 0 0 1 0 9.562Z"
    />
  </svg>
)
export default WindowsSearch